import { useState } from 'react';
import { httpPut } from '../../../../components/utils';

export const useUpdateDefaultStaleSetting = (onSuccess: () => void) => {
    const reqUrl = `/accessAnalysis/defaultStaleAccessSettings`;
    
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);

    const updateDefaultStaleSetting = async (settings: { resource_id?: string; stale_access_since: number }) => {
        setIsLoading(true);

        try {
            await httpPut(reqUrl, { newValue: settings.stale_access_since });

            onSuccess();
        } catch (e) {
            setIsError(true);
        } finally {
            setIsLoading(false);
        }
    };

    return { updateDefaultStaleSetting, isLoading, isError };
};
